<template>
    <div class="xxdata">
        <vx-card title="基本信息">

            <div  style="xxmax-width: 300px;">
                <table class="td-w100">
<!--                    <tr>-->
<!--                        <td class="font-semibold">类型</td>-->
<!--                        <td>{{ user_data.user_type }}</td>-->
<!--                    </tr>-->
                    <tr>
                        <td class="font-semibold">姓名</td>
                        <td>{{ user_data.real_name }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">账户</td>
                        <td>{{ user_data.username }}</td>
                    </tr>
<!--                    <tr>-->
<!--                        <td class="font-semibold">角色</td>-->
<!--                        <td>{{ user_data.role }}</td>-->
<!--                    </tr>-->
                </table>

            </div>

        </vx-card>

        <vx-card title="权限设置" class="mt-10">
            <div  style="">
                <el-tree
                        ref="tree"
                        default-expand-all
                        :data="menus"
                        show-checkbox
                        node-key="wsCode"
                        :props="defaultProps">
                </el-tree>

                <!--                <role-tree-menu-form ref="tree_form" :tree="menus" />-->
            </div>

        </vx-card>


        <vx-card title="" class="mt-10">
            <div class="p-6" style="">
<!--                <vs-button type="border" color="primary" @click="loadMenus">加载</vs-button>-->

<!--                <gc-cmp-vs-submit-button class="mr-6" :condition="validate" :parameters="getParam" :uri="getSaveUrl"-->
<!--                                         v-on:respond-success="savedOK" v-on:respond-fail="saveFail">保存</gc-cmp-vs-submit-button>-->

                <vs-button type="filled" class="mr-6" color="primary" @click="bindWhIds">保存</vs-button>

                <vs-button type="border" color="danger" @click="cancel">取消</vs-button>

            </div>

        </vx-card>

    </div>
</template>

<script>

    import GcCmpVsSubmitButton from "@/group-cloud/components/vsButton.submit";
    import GcCmpVsInput from "@/group-cloud/components/vsInput";
    import {GC_Validator} from "@/group-cloud/components/validator/Validator";
    import GcCmpFormSelect from "@/group-cloud/components/form/select/GC-Cmp-Select";
    import {Mod_Account, Mod_Account_Types, Mod_Account_Type_Opts, Mod_Account_Type_Map} from '@/modules/server-api/Accounts';
    import {Mod_Roles} from '@/modules/server-api/Roles';
    import {Mod_Role_Warehouse} from "../../server-api/RoleWarehouse";
    import {Navigator} from "@/router/Navigator";
    import RoleTreeMenuForm from "./menu_tree_form";

export default {
    components: {
        RoleTreeMenuForm,
        GcCmpFormSelect,
        GcCmpVsInput,
        GcCmpVsSubmitButton,
    },
    data () {
        return {
            user_id: 0,
            role_id: 0,
            role_name: '',
            rolesMap: {},
            user_data: {
                user_type: '',
                real_name: '',
            },
            user_type: Mod_Account_Types.HEAD_QUARTER,
            account_opts: Mod_Account_Type_Opts,
            roles: [],
            menus: [],
            loaded: false,
            defaultProps:{
                label:'title',
            }
        }
    },
    computed: {
        getSaveUrl() {
            return  'auth_center/yooz/role/sync_warehouse_map';
        },

    },
    watch: {
        user_type(update) {
            // this.getAllMenus();
        }
    },
    methods: {
        validate() {
            return true;
        },
        async getAllMenus() {

            // let allWhs = await Mod_Role_Warehouse.getWarehouseList();
            // let allWhs_2 = await Mod_Role_Warehouse.getWarehouseList_wms();
            // console.log(['allWhs_2', allWhs_2]);

            let allWhs = await Mod_Role_Warehouse.getWarehouseList_wms_skip_role_check();

            let userId = this.user_id;
            // let menuIds = await Mod_Role_Warehouse.getWhMap(userId);

            // console.log(['menus',  menuIds]);

            // if (allWhs.length) {
            //
            //     Mod_Roles.markCheckedTree(allWhs, menuIds);
            //
            //     this.menus = allWhs;
            // }
            // console.log(['menus',  this.menus]);

            this.menus = allWhs;
            return allWhs;
        },

        async getRoleMenus(roleId) {
            let menuIds = await Mod_Roles.getRoleMenus(roleId);

        },
        loadMenus() {
            this.getAllMenus();
        },
        async bindWhIds() {
            let menus = this.$refs['tree'].getCheckedNodes();
            let menuArr = [];
            let arr = menus.find(item=>{
                return item.title === '全部'
            })
            if(arr){
                menus.splice(0,1);
                menuArr = menus;
            }else{
                menuArr = menus;
            }

            // console.log(['menus', menus]);
            let bindOk = await Mod_Role_Warehouse.syncWhMap(this.user_id, menus);
            console.log(['save-warehouse-ids', menus, bindOk]);
            //
            if (bindOk) {
                this.$notifySuccess('保存成功');
                this.closeForm();
            } else {
                this.$notifyError('保存失败');
            }
        },
        // 确认取消
        cancel(){
            this.$vs.dialog({
            type: "confirm",
            title: `请确认`,
            text: `是否确认取消`,
            acceptText: "确认",
            cancelText: "取消",
            accept: () => {
            this.closeForm();
            },
           });
        },
        closeForm() {
            let path = `/modules/role_warehouse/list`;
            Navigator.redirect(path);
        },

        async loadUserInfo(uid) {

            let group = Mod_Account_Types.HEAD_QUARTER;
            // this.rolesMap = await Mod_Roles.getRolesMap(group);

            let resp = await Mod_Account.loadUser(uid);
            // console.log(['load-user-resp', this.rolesMap, resp]);
            console.log(resp);
            this.user_data.real_name = resp.data.user.realname;
            this.user_data.username = resp.data.user.username;
            let checkArr = [];
            if(resp.data.wes.length>0){
                resp.data.wes.forEach(item=>{
                    checkArr.push(item.wsCode);
                })
            }
            console.log(checkArr);
            this.$nextTick(()=>{
                this.$refs["tree"].setCheckedKeys(checkArr);
            })

            // this.user_data.user_type = Mod_Account_Type_Map[group];

            // if (resp.one_role && resp.one_role.role_id && this.rolesMap[resp.one_role.role_id]) {
            //     this.user_data.role = this.rolesMap[resp.one_role.role_id];
            // }
            //
            // if (resp.id > 0) {
            //     this.role_name     = resp.rolename;
            //     this.user_type     = resp.group_id;
            // } else {
            //     this.role_name     = '';
            //     this.user_type     = Mod_Account_Types.HEAD_QUARTER;
            // }
            return resp;
        },
        async init(route) {
            let _route = route || this.$route;
            if (_route.params.user_id > 0) {
                this.user_id = parseInt(_route.params.user_id);
            } else {
                this.user_id = 0;
            }
            await this.loadUserInfo(this.user_id);
            await this.getAllMenus();
        },
    },
    beforeRouteUpdate (to, from, next) {
        // console.log('route-change', to);
        this.init(to);

    },
    created() {
        this.init();
    }
}
</script>

<style lang="scss" scoped>

    table.td-w100 {
        td {
            min-width: 100px;
        }
    }

</style>
